<template>
    <div>
        <h1 class="font-bold text-4xl mb-20">Cafes added by you</h1>

        <p>This feature is still a work in progress. Here you can see all the cafes that you have contributed to the
            site.
            You can't update them yet, but if there's anything that needs to be changed don't hesitate to reach out to
            me.</p>

        <div v-if="!loading">
            <WorkplaceGrid
                :cafes="cafes"/>

            <p v-if="cafes.length === 0">
                You have not added any cafes yet. Add one by browsing to the city's page and clicking the link to add a
                new
                city! If you can't find the city you're looking for, please send me a Tweet or an email at
                max@maxkorlaar.com and I'll add it!</p>
        </div>
    </div>
</template>

<script>
import WorkplaceGrid from "../../../components/WorkplaceGrid";
import axios from "axios";

export default {
    name: "WorkplacesIndex",
    components: {WorkplaceGrid},
    data() {
        return {
            cafes: [],
            loading: true,
            errors: {},
        }
    },
    created() {
        this.loadCafes();
    },
    methods: {
        loadCafes() {
            this.loading = true;

            axios.get(`/api/user/workplaces`).then(response => {
                this.cafes = response.data;
            }).catch(error => {
                this.errors = error.response?.data?.errors ?? {};
                alert('Something went wrong while loading the workplaces you\'ve added. Please try again later.');
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>
